<template>
    <article class="flex">
        <picture class="min-w-[140px] w-[140px] h-[100px] bg-white items-center justify-center flex mr-3">
            <img :src="article.image" alt="" class="max-w-full max-h-full">
        </picture>
        <header class="flex flex-col justify-between w-full">
            <h3 class="text-white font-bold leading-7 text-sm overflow-ellipsis max-h-8 overflow-hidden line-clamp-1">{{ article.title }}</h3>
            <Link class="bg-yellow-500 text-pink-900 text-xs font-bold py-0.5 p-2.5 rounded-3xl w-[fit-content] self-center" :href="route('news.show', article.id)">Veja mais</Link>
        </header>
    </article>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components:{
        Link
    },
    props:{
        article: {
            type: Object,
            default: {}
        }
    }
}
</script>
